import { useLingui } from '@lingui/react/macro'
import { CheckMark } from 'features/timeSeries/components/panes/TagFilterControls'
import {
  CellText,
  DescriptionText,
  TagRowButton,
  UnitText,
} from 'features/timeSeries/components/panes/tagSearchDialog.styles'
import { MAX_PENS } from 'features/timeSeries/config/constants'
import React from 'react'
import { ListChildComponentProps } from 'react-window'
import { BaseSensorEntry } from 'types'

export interface DialogRowData {
  tags: BaseSensorEntry[]
  draftIds: Set<string>
  atPenCap: boolean
  onToggle: (tag: BaseSensorEntry) => void
}

export const TagSearchDialogRow: React.FC<
  ListChildComponentProps<DialogRowData>
> = ({ index, style, data }) => {
  const { t } = useLingui()

  const tag = data.tags[index]
  const isSelected = data.draftIds.has(tag.id)
  const disabled = !isSelected && data.atPenCap
  return (
    <TagRowButton
      type='button'
      style={style}
      disabled={disabled}
      aria-pressed={isSelected}
      title={disabled ? t`Pen limit reached (${MAX_PENS})` : undefined}
      onClick={() => data.onToggle(tag)}>
      <CheckMark checked={isSelected} />
      <CellText>{tag.data.name}</CellText>
      <DescriptionText>{tag.data.description ?? ''}</DescriptionText>
      <UnitText>{tag.data.unit ?? ''}</UnitText>
    </TagRowButton>
  )
}
